module.exports = __webpack_public_path__ + "login.a72b87d2.mp4";